import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormatter',
  pure: false,
})
export class PhoneFormatterPipe implements PipeTransform {
  transform(value: string, masked: boolean): string {
    if (!value) {
      return value;
    }

    if (!masked) {
      return value;
    }

    let markedStr = '';
    for (let i = 0; i < value?.length; i++) {
      if (i < 3 || i >= value.length - 4) {
        markedStr += value[i];
      } else {
        markedStr += '*';
      }
    }

    return markedStr;
  }
}
